import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Calistay.css';
import calistayAltFoto from '../../assets/calistay.jpeg'; 

function Calistay() {
  return (
    <div className="calistay-page">
      <Navbar />
      
      <main className="calistay-container">
        <div className="image-content">
          <img 
            src={calistayAltFoto} 
            alt="34. UYOK Metodoloji Çalıştayı" 
            className="centered-image" 
          />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Calistay;